import { combineReducers } from 'redux'

export const Types = {
  ADD_PRODUCT: 'add_product',
  ADD_PRODUCT_SUCCESS: 'add_product_success',
  ADD_PRODUCT_ERROR: 'add_product_error',
  RETRIEVE_CART: 'retrieve_cart',
  RETRIEVE_CART_SUCCESS: 'retrieve_cart_success',
  RETRIEVE_CART_ERROR: 'retrieve_cart_error',
}

export function addProduct(payload) {
  return {
    type: Types.ADD_PRODUCT,
    payload,
  }
}

export function addProductSuccess(payload) {
  return {
    type: Types.ADD_PRODUCT_SUCCESS,
    payload,
  }
}

export function addProductError(payload) {
  return {
    type: Types.ADD_PRODUCT_ERROR,
    payload,
  }
}

export function retrieveCart() {
  return {
    type: Types.RETRIEVE_CART,
  }
}

export function retrieveCartSuccess(payload) {
  return {
    type: Types.RETRIEVE_CART_SUCCESS,
    payload,
  }
}

export function retrieveCartError(payload) {
  return {
    type: Types.RETRIEVE_CART_ERROR,
    payload,
  }
}

function itemsReducer(state = [], action) {
  switch (action.type) {
    case Types.ADD_PRODUCT:
      return [...state, ...[action.payload]]
    case Types.RETRIEVE_CART_SUCCESS:
      return [...state, ...action.payload]
    default: return state
  }
}

export default combineReducers({
  items: itemsReducer,
})
